.form { display: flex; flex-direction: column; gap: 14px; }
.field { display: flex; flex-direction: column; gap: 6px; }
.label { font-size: var(--fs-sm); color: var(--text-secondary); }
.hint { color: var(--text-muted); font-weight: normal; }
.error {
  padding: 10px 12px;
  border-radius: var(--r-sm);
  background: color-mix(in oklab, var(--danger) 18%, transparent);
  border: 1px solid color-mix(in oklab, var(--danger) 40%, transparent);
  color: #ffd0d0;
  font-size: var(--fs-sm);
}
.altLinks { display: flex; justify-content: space-between; gap: 12px; margin-top: 4px; }
.link {
  font-size: var(--fs-sm);
  color: var(--text-secondary);
  text-decoration: underline;
}
.link:hover { color: var(--accent-hover); }
.lede { color: var(--text-secondary); margin: 0 0 8px; }
.divider {
  text-align: center; color: var(--text-muted); font-size: var(--fs-sm);
  position: relative;
}
.divider::before, .divider::after {
  content: ''; position: absolute; top: 50%; width: 40%; height: 1px; background: var(--border);
}
.divider::before { left: 0; } .divider::after { right: 0; }

.done { text-align: center; padding: 16px 0; }
.done h3 { margin: 0 0 6px; }
.done p { margin: 0 0 16px; }
